import React, { useContext, useEffect, useState } from "react";
import "./Login.css";
import NavBar from "./../Header/NavBar/NavBar";
import { useForm } from "react-hook-form";
import { vestResolver } from "@hookform/resolvers/vest";
import { validationSuite, validationSuite2 } from "./validation";
import { Alert } from "react-bootstrap";
import axios from "axios";
import { useHistory, useLocation } from "react-router";

const Login = () => {
  const [errMsg, setErrMsg] = useState(null);

  let history = useHistory();
  let location = useLocation();
  let { from } = location.state || { from: { pathname: "/" } };

  let redirectNow = async () => {
    let userData = await JSON.parse(localStorage.getItem("user"));
    userData && userData?.token && history.replace(from);
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: vestResolver(validationSuite),
  });

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    reset: reset2,
    formState: { errors: errors2 },
  } = useForm({
    mode: "onBlur",
    resolver: vestResolver(validationSuite2),
  });

  const onSubmit = (data) => {
    loginHandler(data);
    // console.log(data);
  };
  const onSubmit2 = (data) => {
    // console.log(data);
    signUpHandler(data);
  };

  const loginSignupWorkHandler = async (userData, filedName) => {
    try {
      setErrMsg(null);
      const response = await axios.post(
        `https://mysterious-sierra-48850.herokuapp.com/${filedName}`,
        userData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      await localStorage.setItem("user", JSON.stringify(response.data));
      await reset();
      await redirectNow();
    } catch (error) {
      console.error(error?.response?.data);
      setErrMsg(error?.response?.data.msg);
    }
  };

  const loginHandler = async (userData) =>
    loginSignupWorkHandler(userData, "login");
  const signUpHandler = (userData) =>
    loginSignupWorkHandler(userData, "signup");

  useEffect(() => {
    console.log(errors);
    console.log(errors2);
  }, [errors, errors2]);

  const toggleForm = () => {
    const container = document.querySelector(".login_container");
    container.classList.toggle("active");
    // reset();
  };

  const showError = (errName) => errName && errName.message;

  return (
    <>
      <NavBar />
      <section className="login">
        <div className="login_container">
          <div className="user signinBx">
            <div className="imgBx">
              <img
                className="img-fluid"
                src="https://images.unsplash.com/photo-1584380931214-dbb5b72e7fd0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8Z3ltJTIwZ2lybHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60"
                alt="gym"
              />
            </div>
            <div className="formBx">
              <form onSubmit={handleSubmit(onSubmit)}>
                <h2>Sign In</h2>
                {errMsg && (
                  <Alert variant="danger" className="mt-1 text-center">
                    {errMsg}
                  </Alert>
                )}
                <input
                  type="text"
                  name="userName"
                  placeholder="Username"
                  {...register("userName", { required: true })}
                />
                <span className="text-danger d-block">
                  {showError(errors.userName)}
                </span>
                <input
                  type="password"
                  name="password"
                  placeholder="password"
                  {...register("password", { required: true })}
                />
                <span className="text-danger d-block">
                  {showError(errors.password)}
                </span>
                <input type="submit" value="Login" />
                <p className="signin">
                  Don't have an account?{" "}
                  <span className="link" onClick={toggleForm}>
                    Sign Up.
                  </span>
                </p>
              </form>
            </div>
          </div>

          <div className="user signupBx">
            <div className="formBx">
              <form onSubmit={handleSubmit2(onSubmit2)}>
                <h2>Create an account</h2>
                <input
                  type="text"
                  placeholder="Username"
                  {...register2("userName", { required: true })}
                />
                <span className="text-danger d-block">
                  {showError(errors2.userName)}
                </span>

                <input
                  type="text"
                  placeholder="Name"
                  {...register2("name", { required: true })}
                />
                <span className="text-danger d-block">
                  {showError(errors2.name)}
                </span>

                <input
                  type="email"
                  placeholder="Email Address"
                  {...register2("email", { required: true })}
                />
                <span className="text-danger d-block">
                  {showError(errors2.email)}
                </span>
                <input
                  type="password"
                  placeholder="Create Password"
                  {...register2("password", { required: true })}
                />
                <span className="text-danger d-block">
                  {showError(errors2.password)}
                </span>
                <input
                  type="password"
                  placeholder="Confirm Password"
                  {...register2("confirmPassword", { required: true })}
                />
                <span className="text-danger d-block">
                  {showError(errors2.confirmPassword)}
                </span>
                <input type="submit" value="Sign Up" />
                <p className="signup">
                  Already have an account?{" "}
                  <span className="link" onClick={toggleForm}>
                    Sign In
                  </span>
                </p>
              </form>
            </div>
            <div className="imgBx">
              <img
                className="img-fluid"
                src="https://images.unsplash.com/photo-1584464457692-54516d705fe0?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTV8fGd5bSUyMGdpcmx8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                alt="gym"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
